import moment from "moment";
export default ({ dueDate, completedAt }) => moment(new Date(completedAt || new Date())).isAfter(new Date(dueDate));
